<app-table
    #tableOperations
    [tableTitle]="prefix + 'label'"
    [columns]="columns()"
    [translatePrefix]="prefix"
    [hideCheckboxes]="true"
    [gridData]="store.data.getWarehouseMaterialOperations()"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.getWarehouseMaterialOperations"
    [refreshCallbackFragment]="tableFrag()"
    [defaultSorters]="[{ column: 'date', direction: 'DESC' }]"
    [showCreate]="!disabled()"
    [showDetail]="!disabled()"
    [showDelete]="!disabled()"
    (detailCallback)="store.isAllowed('warehouseMaterial.update')() && edit($event)"
    (createCallback)="store.isAllowed('warehouseMaterial.create')() && create()"
    (deleteCallbackWithEvent)="store.isAllowed('warehouseMaterial.delete')() && handleDeleteItemClick($event)"
>
    <ng-template let-data="data" pTemplate="type">
        {{ prefix + 'type.' + data | translate }}
    </ng-template>

    <ng-template let-item="item" pTemplate="folderId">
        @if (item.folder?.person) {
            {{ item.folder.person | formatPerson }}
        }
    </ng-template>

    <ng-template let-item="item" pTemplate="workers">
        <div class="flex gap-2">
            @for (user of item.workers; track $index) {
                <app-user-chip [user]="user"></app-user-chip>
            }
        </div>
    </ng-template>

    <ng-template let-item="item" pTemplate="warehouseMaterial">
        {{ item.warehouseMaterial?.name }}
    </ng-template>

    <ng-template let-item="item" pTemplate="work">
        @if (item.work) {
            <button class="p-button p-component appBtn p-button-link" (click)="goToWorkDetail(item.work)">
                {{ prefix + 'work' | translate }} {{ item.work?.dateFrom | date: 'd.M.y HH:mm' }}
            </button>
        }
    </ng-template>

    <ng-template let-item="item" pTemplate="amountIssued">
        @if (item.type === WarehouseMaterialOperationTypeEnum.ISSUED) {
            {{ item.amount }}
        } @else {
            0
        }
    </ng-template>

    <ng-template let-item="item" pTemplate="amountReturned">
        @if (item.type === WarehouseMaterialOperationTypeEnum.RETURNED) {
            {{ item.amount }}
        } @else {
            0
        }
    </ng-template>
</app-table>
